import { DatePipe } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Component } from "@angular/core";
import { LoadingController, NavController, Platform, ToastController } from "ionic-angular";
import { DataProvider } from "../../providers/data/data";
import { RestProvider } from "../../providers/rest/rest";
declare var google
@Component({
  selector: "app-sim",
  templateUrl: "sim.html"
})
export class SimPage {
  public Array = [];
  public simMasterTable = [];
  public loader;
  public Er;
  public Em;
  public Date;
  public sData = [];
  public Niit = [];
  public seasons = [];
  public Osolt = [];
  public seasonName = '';
  public seasonStartDate = '';
  public seasonEndDate = '';
  public SimMode: boolean = false;
  public sum_ows = 0;
  public sum_tejeel = 0;
  public farm_group = [];
  public farms = [];

  constructor(
    public navCtrl: NavController,
    private rest: RestProvider,
    public loadingCtrl: LoadingController,
    protected datepipe: DatePipe,
    public http: HttpClient,
    private data: DataProvider,
    public platform: Platform,
    private toastCtrl: ToastController,
  ) {
  }

  showLoader(content?: string) {
    if (this.loader) {
      this.loader.dismiss();
    }
    this.loader = this.loadingCtrl.create({
      content: content ? content : "Ачаалж байна..."
    })
    this.loader.present();
    this.loader.onDidDismiss(() => {
      this.loader = null;
    })
  }

  hideLoader() {
    if (this.loader)
      this.loader.dismiss();
  }
  
  ionViewDidEnter(): void {
    document.getElementById('mainmenu').style.visibility = 'visible';
    document.getElementById('backmenu').style.display = 'block';
    document.getElementById('mainHeader').style.display = 'block';
    document.getElementById('backFrom').innerText = 'block';
    this.data.currentTabName = 'Симуляци';
  }

  ionViewDidLoad() {
    this.farms = JSON.parse(localStorage.getItem('farms'));
    this.simMasterTable = JSON.parse(localStorage.getItem('simMasterTable'));
    this.rest.SeasonsMaster().subscribe(
      (res) => {
        console.log(res);
        this.seasons = res;
      },
      (err) => {
        console.log(err);
      }
    );
  }
  
  daysToMilliseconds(days) {
    return days * 24 * 60 * 60 * 1000;
  }

  showToast1(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 3000,
      cssClass: "toast-unsuccess"
    });
    toast.present();
  }

  showToast(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 3000,
      cssClass: "toast-success"
    });
    toast.present();
  }

  validation(){
    let err = false;
    if (!this.SimMode) {
      if (this.Em == null || this.Em == '' && this.Em >= 0) {
        err = true;
        this.showToast1('Үхрийн тоо оруулна уу.Em');
      }
      if (this.Er == null || this.Er == '' && this.Er >= 0) {
        err = true;
        this.showToast1('Үхрийн тоо оруулна уу.Er');
      }
    }
      if (this.Date == null || this.Date == '') {
        err = true;
        this.showToast1('Симуляци үргэлжлэх хоногийг оруулна уу.');
      }
    if (err) {
      return false;
    }
    return true;
  }

  drawChart() {
    this.showLoader();
    this.sum_ows = 0;
    this.sum_tejeel = 0;
    document.getElementById('sim_chart').style.display = "block";
    document.getElementById('osolt_chart').style.display = "block";
    console.log(this.SimMode);
    console.log(this.farm_group);
    if (!this.validation()) {
      this.hideLoader();
      return true;
    } else {
      if(this.SimMode) {
        this.Em = '';
        this.Er = '';
      }
      this.rest.StartSim(this.Em, this.Er, this.Date, this.SimMode, this.farm_group).subscribe(
        (res) => {
          console.log(res);
          this.Array = res.list;
          this.Niit = res.tejeel;
          for (let i1 = 0; i1 < this.Niit.length; i1++) {
            this.sum_ows += this.Niit[i1].niit_ows;
            this.sum_tejeel += this.Niit[i1].niit_tejeel;
          }
          this.Osolt = res.osolt;
          this.OsoltChart();
          if (res.result) {
            var dataTable = new google.visualization.DataTable();   
            dataTable.addColumn({ type: 'string', id: 'name' });
            dataTable.addColumn({ type: 'string', id: 'status' });
            dataTable.addColumn({ type: 'date', id: 'start_date' });
            dataTable.addColumn({ type: 'date', id: 'end_date' });
            for(let i = 0; i < this.Array.length; i++){
              let innerArray = [];
              innerArray.push(this.Array[i].CowName);
              innerArray.push(this.Array[i].CowStatusName);
              innerArray.push(new Date(this.datepipe.transform(this.Array[i].StartDate, 'yyyy-MM-dd')));
              innerArray.push(new Date(this.datepipe.transform(this.Array[i].EndDate, 'yyyy-MM-dd')));
              dataTable.addRows([
                innerArray
                ]);
            }
            var chart = new google.visualization.Timeline(document.getElementById('sim_grap'));
            chart.draw(dataTable, { width: this.Date * 10 });
            let s = this.platform.width() - 20;
            document.getElementById("sim_chart").style.width = s + 'px';
            this.hideLoader();
          } else {
            this.hideLoader();
          };
        },
        (err) => {
          console.log(err);
          this.hideLoader();
        }
      );
    }
  }
  FarmGroup(id){
    // if(this.farm_group.includes(id)) {
      this.farm_group = this.farm_group.filter((value)=>value!=id);
    // } else {
      this.farm_group.push(id);
    // }
  }
  UpdateSeason(list) {
    this.showLoader();
    if (!this.season_validation(list)) {
      this.hideLoader();
      return true;
    } else {
      this.rest.seasonUpdate(list.id, list.season_name, list.start_date, list.end_date).subscribe(
        (res) => {
          console.log(res);
          if (res.result) {
            this.rest.SeasonsMaster().subscribe(
              (res) => {
                console.log(res);
                this.seasons = res;
                this.hideLoader();
                this.showToast('амжилттай шинэчлэгдсэн.');
              },
              (err) => {
                this.hideLoader();
                this.showToast1('Алдаа гарсан');
              }
            );
          } else {
            this.hideLoader();
            this.showToast1('Алдаа гарсан');
          }
        },
        (err) =>{
          console.log(err);
          this.hideLoader();
          this.showToast1('Алдаа гарсан');
        }
      );
    }
  }
  Update(value) {
    this.showLoader();
    console.log("Update::::::", value);
    this.rest.simMasterUpdate(
      value.id,
      value.type,
      value.status,
      value.nextstatus,
      value.isnewitem,
      value.statusname,
      value.minval,
      value.maxval, 
      value.ows,
      value.tejeel
    ).subscribe(
      (res) => {
        console.log(res);
        
        if (res.result) {
          this.rest.simMasterTable().subscribe(
            (res) => {
              localStorage.setItem('simMasterTable', JSON.stringify(res));
              this.showToast('амжилттай шинэчлэгдсэн.');
              this.hideLoader();
            },
            (err) => {
              this.hideLoader();
              this.showToast1('Алдаа гарсан');
            }
          );
        } else {
          this.hideLoader();
          this.showToast1('Алдаа гарсан');
        }
      },
      (err) => {
        console.log(err);
        this.hideLoader();
        this.showToast1('Алдаа гарсан');
      }
    );
  }
  
  season_validation(list){
    let err = false;
    if (list == '') {
      if (this.seasonName == null || this.seasonName == '') {
        err = true;
        this.showToast1('Улирал нэр оруулна уу!');
      }
      if (this.seasonStartDate == null || this.seasonStartDate == '') {
        err = true;
        this.showToast1('Улирал эхлэх огноо оруулна уу!');
      }
      if (this.seasonEndDate == null || this.seasonEndDate == '') {
        err = true;
        this.showToast1('Улирал дуусах огноо оруулна уу!');
      }
      if (new Date(this.seasonStartDate).getTime() >= new Date(this.seasonEndDate).getTime()) {
        err = true;
        this.showToast1('Дуусах огноо эхлэх огнооноос хойш байх!');
      }
    } else {
      if (list.season_name == null || list.season_name == '') {
        err = true;
        this.showToast1('Улирал нэр оруулна уу!');
      }
      if (list.start_date == null || list.start_date == '') {
        err = true;
        this.showToast1('Улирал эхлэх огноо оруулна уу!');
      }
      if (list.end_date == null || list.end_date == '') {
        err = true;
        this.showToast1('Улирал дуусах огноо оруулна уу!');
      }
      if (new Date(list.start_date).getTime() >= new Date(list.end_date).getTime()) {
        err = true;
        this.showToast1('Дуусах огноо эхлэх огнооноос хойш байх!');
      }
    }
    if (err) {
      return false;
    }
    return true;
  }
  NewSeason(){
    this.showLoader();
    var list = '';
    if (!this.season_validation(list)) {
      this.hideLoader();
      return true;
    } else {
      this.rest.insertSeason(this.seasonName, this.seasonStartDate, this.seasonEndDate).subscribe(
        (res) => {
          console.log(res);
          if (res.result) {
            this.rest.SeasonsMaster().subscribe(
              (res) => {
                console.log(res);
                this.seasons = res;
                this.hideLoader();
                this.showToast('амжилттай хадгалсан.');
                this.seasonName = '';
                this.seasonStartDate = '';
                this.seasonStartDate = '';
              },
              (err) => {
                this.hideLoader();
                this.showToast1('Алдаа гарсан');
              }
            );
          } else {
            this.hideLoader();
            this.showToast1('Алдаа гарсан');
          }
        },
        (err) => {
          this.hideLoader();
          console.log(err);
          this.showToast1('Алдаа гарсан');
        }
      );
    }
  }
  DeleteSeason(id){
    this.showLoader();
    this.rest.seasonDelete(id).subscribe(
      (res) => {
        console.log(res);
        if (res.result) {
          this.rest.SeasonsMaster().subscribe(
            (res) => {
              console.log(res);
              this.seasons = res;
              this.hideLoader();
              this.showToast('амжилттай устсан.');
              this.seasonName = '';
              this.seasonStartDate = '';
              this.seasonStartDate = '';
            },
            (err) => {
              this.hideLoader();
              this.showToast1('Алдаа гарсан');
            }
          );
        } else {
          this.hideLoader();
          this.showToast1('Алдаа гарсан');
        }
      },
      (err) => {
        this.hideLoader();
        console.log(err);
        this.showToast1('Алдаа гарсан');
      }
    )
  }
  OsoltChart() {
    console.log(this.Osolt);
    var arrayData = [];
    var header = ['Year'];
    var ID = ['ID'];
    for(let k = 0; k < this.simMasterTable.length; k++){
      header.push(this.simMasterTable[k].statusname);
      ID.push(this.simMasterTable[k].id);
    }
    console.log(header);
    arrayData.push(header);
    for(let i = 0; i < this.Osolt.length; i++) {
      let innerArray = [];
      innerArray.push(this.datepipe.transform(this.Osolt[i].date, 'MM-dd'));
      for(let h = 1; h < ID.length; h++) {
        innerArray.push(this.Osolt[i].data[ID[h]] == undefined ? 0 : this.Osolt[i].data[ID[h]]);
      }
      arrayData.push(innerArray);
    }
    console.log(arrayData);
    var data = google.visualization.arrayToDataTable(arrayData);
    var options = {
      title: "Өсөлтийн график",
      width: this.Date * 10,
      height: 400,
      legend: { position: 'none', maxLines: 3 },
      bar: { groupWidth: '100%' },
      isStacked: 'absolute',
    };
    var chart = new google.visualization.ColumnChart(document.getElementById("osolt_grap"));
    chart.draw(data, options);
  }
}


// WEBPACK FOOTER //
// ./src/pages/sim/sim.ts